import React from 'react';
import { THEME_2026 } from '../lib/theme2026';
import CharlieWordmark from './CharlieWordmark';

// WO-2912 amendment: use CHARLIE's real typographic wordmark on the
// navy loading screen. Keep this screen quiet while the app initializes.
export default function LoadingScreen({ fadeOut }) {
  return (
    <div
      data-testid="loading-screen"
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: THEME_2026.primaryBg,
        opacity: fadeOut ? 0 : 1,
        transition: 'opacity 0.6s ease',
        pointerEvents: fadeOut ? 'none' : 'auto',
      }}
    >
      <div style={{ textAlign: 'center' }}>
        <CharlieWordmark
          wordmarkTestId="loading-wordmark"
          fontSize="clamp(28px, 5vw, 40px)"
          letterSpacing="0.14em"
          sublineSize="clamp(10px, 1.5vw, 12px)"
          sublineSpacing="0.2em"
          sublineMarginTop={10}
        />
      </div>
    </div>
  );
}
